<template>
  <div class="height-calendar">
    <div class="p-4">
      <div class="mb-6">
        <h3 class="font-semibold flex items-center text-black my-0 text-2xl">
          Recommendations
          <div
            v-tooltip.top="{
              content:
                'Suitable campaign types for your business, based on your profile on the platform.',
              class: 'toolcust',
            }"
          >
            <feather-icon
              icon="InfoIcon"
              class="ml-1 text-grey flex cursor-pointer"
              svgClasses="w-5 h-5"
            />
          </div>
        </h3>
        <p class="fsize12 font-normal mt-2 text-8f8f8f">
          Leverage these campaigns for maximum exposure
        </p>
      </div>
      <div class="grid grid-cols-4 gap-4">
        <div
          v-for="(campaign, index) in campaings"
          :key="'campaign' + index"
          class="p-4 bg-eds rounded-12px"
        >
          <img
            :src="campaign.image"
            class="object-contain mb-2 h-24 w-full mx-auto"
            alt="banh"
          />
          <!-- <p class="col-4f fsize10 font-semibold">0123458</p> -->
          <!-- <h3 class="font-semibold text-black fsize16">
            {{ event.eventTitle }}
          </h3> -->
          <!-- <div class="flex justify-between w-full mt-3">
            <div>
              <p class="fsize10 font-semibold mb-0 col-4f">Date</p>
              <p class="fsize10 mb-0 text-8f8f8f">
                {{ new Date(event.eventDate).toDateString() }}
              </p>
            </div>
            <div>
              <p class="fsize10 font-semibold mb-0 col-4f">Status</p>
              <p class="fsize10 mb-0 font-semibold text-success">Completed</p>
            </div>
          </div> -->
          <vs-button
            variant="primary"
            class="rounded-full mt-4 bg-primary border-0 text-white font-medium fsize10 mt-4 lg:py-3 md:py-3 py-2 w-full sm-fsize14"
            @click="handleClick(campaign.route)"
          >
            Get Started
          </vs-button>
        </div>
      </div>
    </div>
    <!-- <div class="mt-12">
      <div class="mb-4">
        <p class="fsize12 font-semibold mb-0 text-primary">Brained Studio</p>
        <h3 class="font-semibold pt-1 text-black my-0 text-2xl">
          Social Media Content
        </h3>
        <p class="fsize12 font-normal mt-2 text-8f8f8f">
          Brained content for your online presence
        </p>
      </div>
      <div class="grid grid-cols-3 gap-4">
        <div class="rounded-16px elshadow">
          <img
            src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/marcom/icecream.png"
            class="object-cover h-150px rounded-tlr-16px w-full"
            alt="banh"
          />
          <div class="p-4">
            <h3 class="font-semibold text-black fsize16">Branded Videos</h3>
            <p class="fsize12 font-normal mt-2 text-8f8f8f">
              Create a custom video greeting to represent your brand.
            </p>
          </div>
        </div>

        <div class="rounded-16px elshadow">
          <img
            src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/marcom/plant.png"
            class="object-cover rounded-tlr-16px h-150px w-full"
            alt="banh"
          />
          <div class="p-4">
            <h3 class="font-semibold text-black fsize16">Branded Media Post</h3>
            <p class="fsize12 font-normal mt-2 text-8f8f8f">
              Create a custom video greeting to represent your brand.
            </p>
          </div>
        </div>
      </div>
    </div> -->
    <div class="mt-10">
      <BrandingGallery :events="events" />
    </div>
  </div>
</template>
<script>
import BrandGall from "./BrandGall.vue";
import BrandingGallery from "../../branding/components/BrandingGallery.vue";
export default {
  components: {
    BrandGall,
    BrandingGallery,
  },
  props: {
    events: {
      type: Array,
      default: [],
    },
    event: {
      type: Object,
      default: () => "",
    },
  },
  data() {
    return {
      CampaignsCard: [
        {
          name: "SMS Campaign",
          image: require("@/assets/images/airplane.png"),
          route: "SMS-Campaign",
          class: "bg-cas",
          type: "SMS",
        },
        {
          name: "Push Notification",
          image: require("@/assets/images/bell.png"),
          route: "pushNotification-Campaign",
          class: "bg-yellows",
          type: "PN",
        },
        {
          name: "Email Campaign",
          image: require("@/assets/images/main.png"),
          route: "email-Campaign",
          class: "bg-blues",
          type: "EMAIL",
        },
        {
          name: "Whatsapp Campaign",
          image:
            "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/whatsapp.png",
          route: "whatsapp-Campaign",
          class: "bg-grens",
          type: "WA",
        },
      ],
      filteredCampaigns: [],
    };
  },

  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },

  // watch: {
  //   event(value) {
  //     console.log(value, "EVENT");
  //     if (value !== "" && value != "undefined" && value.campaigns.length) {
  //       let camps = value.campaigns.map((x) => {
  //         return x.name;
  //       });
  //       console.log(camps);
  //       this.filteredCampaigns = this.CampaignsCard.filter((x) =>
  //         camps.includes(x.type)
  //       );
  //     } else  {
  //       this.filteredCampaigns = this.CampaignsCard;
  //     }
  //   },
  // },

  computed: {
    campaings() {
      if (this.value != undefined && this.value.campaigns.length) {
        let camps = this.value.campaigns.map((x) => {
          return x.name;
        });
        console.log(camps);
        return this.CampaignsCard.filter((x) => camps.includes(x.type));
      } else {
        return this.CampaignsCard;
      }
    },
  },
};
</script>
